export const event = {
    data() {
        return {

        }
    },
    activated() {
        this.addEnterListener();
    },
    destroy() {
        this.removeEnterListener();
    },
    beforeRouteLeave(to, from, next) {
        this.removeEnterListener();
        next()
    },
    methods: {
        addEnterListener() {
            if (window.__completeEnterBind__) return;
            window.addEventListener("keydown", this.enterCallback);
            window.__completeEnterBind__ = true;
        },
        removeEnterListener() {
            window.removeEventListener("keydown", this.enterCallback);
            window.__completeEnterBind__ = false;
        },
        enterCallback(e) {
            if (e.keyCode === 13) {
                let index = e.target.classList[0].split('-')[1]
                let index1 = e.target.id
                if (index1 == 'contactCustomerName') {
                    if (this.isEvent) {
                        document.getElementsByClassName('steps-02')[0].focus()
                        this.isEvent = false
                    }
                } else if (index == '02') {
                    document.getElementsByClassName('steps-03')[0].focus()
                } else if (index == '03') {
                    document.getElementsByClassName('steps-04')[0].focus()
                } else if (index == '04') {
                    document.getElementsByClassName('steps-05')[0].focus()
                } else if (index == '05') {
                    document.getElementsByClassName('steps-06')[0].focus()
                } else if (index == '06') {

                }
            }
        }
    }
}
